"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Caption2Strong: function() {
        return _Caption2Strong.Caption2Strong;
    },
    caption2StrongClassNames: function() {
        return _useCaption2StrongStylesstyles.caption2StrongClassNames;
    }
});
const _Caption2Strong = require("./Caption2Strong");
const _useCaption2StrongStylesstyles = require("./useCaption2StrongStyles.styles");
